import React from 'react'

interface HelpMenuItem {
  label: string
  onClick: () => void
}

interface HelpMenuProps {
  items: HelpMenuItem[]
}

/**
 * Popover content for the left-nav Help button. Renders the supplied items as
 * a flat list of menu rows; the caller is responsible for the click side
 * effects (navigation, mailto, closing the popover).
 */
export const HelpMenu: React.FC<HelpMenuProps> = ({ items }) => {
  return (
    <div className="p-1.5">
      {items.map((item) => (
        <button
          key={item.label}
          type="button"
          onClick={item.onClick}
          className="w-full bg-transparent border-0 rounded-md hover:bg-surface-hover transition-colors text-left cursor-pointer"
        >
          <div className="flex items-center px-3 py-1.5">
            <span className="text-sm font-medium text-fg leading-5">
              {item.label}
            </span>
          </div>
        </button>
      ))}
    </div>
  )
}
